import { render, staticRenderFns } from "./ClientHistorical.vue?vue&type=template&id=604a2277&scoped=true&"
import script from "./ClientHistorical.vue?vue&type=script&lang=js&"
export * from "./ClientHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a2277",
  null
  
)

export default component.exports